"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = require("react");
var useOnDidUpdate_1 = __importDefault(require("./useOnDidUpdate"));
var usePropHasChanged = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var _a = react_1.useState(false), hasChanged = _a[0], setHasChanged = _a[1];
    useOnDidUpdate_1["default"](function () {
        requestAnimationFrame(function () {
            setHasChanged(true);
            requestAnimationFrame(function () {
                setHasChanged(false);
            });
        });
    }, args);
    return hasChanged;
};
exports["default"] = usePropHasChanged;
//# sourceMappingURL=usePropHasChanged.js.map